'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import { getCurrentLang } from '../langSwitcher/langSwitcher';
import { CSS2DObject } from '../../../libs/CSS2DRenderer';
import { Cloudflare } from '../../api/Cloudflare';
import { isMobile, settingsData } from '../../../settings';
import { Button } from '../../interfaces/buttons/Button';
import { DreamsPreloader } from '../preloader/DreamsPreloader';
import { PhotoSwiperGallery } from '../../menu/gallery/galleryDesktop';

export class Orbit360Viewer {

  constructor (data) {
    if (!data.url.length) return;
    this.data = data;
    this.url = new URL(data.url);
    this.objectType = 'CSSLabel';
    this.type = this.url.pathname.match(/\.(htm|html)/g) ? '360' : 'img';
    this.preview360Url = data?.preview360;
    this.gallery = data?.gallery && data?.gallery.length > 0 ? data.gallery : null;
    this.label = this.createLabel();
  }

  createLabel() {
    const container = new BaseElement()
      .addClass('orbit-360-label');
    const titles = this.data.title;
    if (titles && Object.keys(titles).length) {
      const translation = titles[getCurrentLang()] || '';
      const title = new BaseElement('span')
        .addClass('poi__title','orbit-360__title','language-string')
        .innerHtml(translation)
        .appendTo(container.DOMElement);
      Object.entries(titles).forEach(([lang,text]) => {
        title.addAttribute(`data-lang-${lang}`,text);
      });
    }
    const icon = new BaseElement()
      .appendTo(container.DOMElement);

    if (this.type === '360') {
      if (Boolean(this.preview360Url)) {
        this.#addPreviewImageToLabel(container, this.preview360Url);
      } else {
        icon.addClass('icon-360');
      }
    } else {
      this.#addPreviewImageToLabel(container, this.url);
    }

    const label = new CSS2DObject(container.DOMElement);
    label.userData.zoom = 1;
    if (!this.data.hasOwnProperty('event') || (this.data.hasOwnProperty('event') && this.data.event)) {
      label.element.addEventListener('click',this.clickHandler.bind(this));
    }
    label.name =`layer-poi__orbit-360`;
    return label;
  }

  #addPreviewImageToLabel(container, imageUrl) {
    container.addClass('image-icon');
    const labelDOM = container.DOMElement;
    const previewIconImage = Cloudflare.resize(imageUrl,{
      width: 200,
      quality: 60
    });
    labelDOM.style.backgroundImage = `url(${previewIconImage})`;
  }

  clickHandler() {
    settingsData.stopRender = true;
    this.mainContainer = new BaseElement()
      .addClass('orbit-360-viewer')
      .appendTo(document.body);
    const content = new BaseElement()
      .addClass('orbit-360-viewer__content')
      .appendTo(this.mainContainer.DOMElement);

    let viewer;

    if (this.type === '360') {
      new Button()
        .addClass('icon-close')
        .event('click', this.closeHandler.bind(this))
        .appendTo(content.DOMElement);
      this.preloader = new BaseElement()
        .addClass('orbit-360-preloader')
        .appendTo(content.DOMElement);
      new DreamsPreloader(this.preloader.DOMElement,'orbit-360-pr').show();
      viewer = new BaseElement('iframe')
        .addClass('orbit-360-viewer__player','player-iframe')
        .addAttribute('src',this.url.href)
        .appendTo(content.DOMElement);
      viewer.DOMElement.onload = () => this.preloader.remove();
    } else {
      viewer = new BaseElement('div')
        .addClass('orbit-360-viewer__player','player-img')
        .appendTo(content.DOMElement);

      let data = this.gallery && this.gallery.length ? this.gallery : [this.url.href];
      data = data.map(url => Cloudflare.resize(url,{width: isMobile ? 1024 : 2880}));
      const gallery = new PhotoSwiperGallery(data,0,viewer.DOMElement);
      gallery.onClose = () => this.closeHandler();
      gallery.open();
    }
  }

  closeHandler() {
    this.mainContainer.remove();
    settingsData.stopRender = false;
  }

  visibilityToggle(state) {
    this.label.visible = state;
  }
}
